module.exports = require("./ff-Adlm-BF.d.ts");